var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapePmm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228.97046242126817 87.97697922515499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-left-center-button-1",
    opacity: 1,
    fillRule: "evenodd",
    d: "M217.97175792910852,47.0000000000001 L228.97046242126942,56.99438517686703 L228.97046242126942,83.00098684770268 L223.97046242126942,87.97697922515499 L10.684615620324045,87.97697922515499 L9.094947017729282e-13,77.25658682317581 L9.094947017729282e-13,1.0000000000001021 L14.07532664395464,0 L91.5410675985006,47.0000000000001 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-2",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(0,187,255)",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(0,187,255)",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-left-center-button-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapePmm);
export default __webpack_public_path__ + "static/media/shape-pmm.73714fd6169b589d349f551e7d97a0c8.svg";
export { ForwardRef as ReactComponent };